import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {
  FileItem,
  InspectionIntegration
} from '@authority-labs/api-interfaces';
import { DirectoryDialogService } from '@check-list/app/shared/dialogs/directory-dialog';

@Component({
  selector: 'authority-labs-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntegrationComponent {
  @Input() data: InspectionIntegration;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Input() orderDirectory: string;
  @Input() orderId: number;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  constructor(private directoryDialogService: DirectoryDialogService) {}

  onDataChange(): void {
    this.dataChange.emit();
  }

  chooseActivationRegimeFile(): void {
    this.directoryDialogService
      .selectFile(this.orderId)
      .afterClosed()
      .subscribe((file) => {
        if (file) {
          this.data.empbededFile = file;
          this.data.empbededFilePages = '';
          this.onDataChange();
        }
      });
  }

  clearFile(): void {
    this.data.empbededFile = new FileItem();
    this.data.empbededFilePages = '';
    this.onDataChange();
  }

  notesBankType(titles: string[]): string {
    return `${this.data.title}_${titles.join('_')}`;
  }
}
